import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ClearIcon from '@mui/icons-material/Clear';
import LocationOffIcon from '@mui/icons-material/LocationOff';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import PanToolIcon from '@mui/icons-material/PanTool';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import WarningIcon from '@mui/icons-material/Warning';
import {
    Alert,
    Box,
    Button,
    ButtonGroup,
    ClickAwayListener,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grow,
    ListItemIcon,
    MenuItem,
    MenuList,
    Paper,
    Popper,
    Tooltip,
    Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

class PrePreenchimentoSplitButton extends React.Component {
    constructor(props) {
        super(props);
        this.anchorRef = React.createRef();
        this.state = {
            open: false,
            selectedIndex: null, // Inicia sem opção selecionada
            dialogAberto: false
        };
    }

    static propTypes = {
        /** Array de objetos representando a composição de magistrados */
        composicao: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                nome: PropTypes.string,
                sigla: PropTypes.string,
                situacaoPresenca: PropTypes.string,
                ausente: PropTypes.bool,
                impedimento: PropTypes.string,
                impedido: PropTypes.bool,
                possivelmenteImpedido: PropTypes.bool,
                siglaDoMagistrado: PropTypes.string
            })
        ),

        /** Função chamada quando uma ação é selecionada e confirmada */
        onAcaoSelecionada: PropTypes.func.isRequired,

        /** Controla se o botão está desabilitado */
        disabled: PropTypes.bool,

        /** Tamanho do botão */
        size: PropTypes.oneOf(['small', 'medium', 'large']),

        /** Variante do botão */
        variant: PropTypes.oneOf(['text', 'outlined', 'contained']),

        /** Cor do botão */
        color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'success', 'error', 'info', 'warning']),

        /** Se o botão deve ocupar toda a largura disponível */
        fullWidth: PropTypes.bool,

        /** Estilos adicionais para o componente */
        sx: PropTypes.object
    };

    static defaultProps = {
        composicao: [],
        disabled: false,
        size: 'medium',
        variant: 'contained',
        color: 'primary',
        fullWidth: false,
        sx: {}
    };

    options = [
        {
            label: 'Pré-preencher Ausentes',
            descricao: 'Magistrados ausentes',
            icon: <LocationOffIcon />,
            action: 'ausentes',
            mensagemConfirmacao: 'Pré-preencher todos os magistrados ausentes?'
        },
        {
            label: 'Pré-preencher Impedidos',
            descricao: 'Magistrados impedidos',
            icon: <PanToolIcon />,
            action: 'impedidos',
            mensagemConfirmacao: 'Pré-preencher todos os magistrados impedidos?'
        },
        {
            label: 'Pré-preencher Poss. Impedidos',
            descricao: 'Magistrados possivelmente impedidos',
            icon: <ThumbDownIcon />,
            action: 'possivelmenteImpedidos',
            mensagemConfirmacao: 'Pré-preencher todos os magistrados possivelmente impedidos?'
        },
        {
            label: 'Pré-preencher Todos Não Votantes',
            descricao: 'Ausentes, impedidos e poss. impedidos',
            icon: <NotInterestedIcon />,
            action: 'todosNaoVotantes',
            mensagemConfirmacao: 'Pré-preencher todos os não votantes (ausentes, impedidos, possivelmente impedidos)?'
        }
    ];

    // Verifica se existem magistrados com determinado status
    verificarDisponibilidade = (tipo) => {
        const { composicao } = this.props;

        if (!composicao || !Array.isArray(composicao)) {
            return false;
        }

        switch (tipo) {
            case 'ausentes':
                return composicao.some(
                    (magistrado) => magistrado.situacaoPresenca === 'AUSENTE' || magistrado.ausente === true
                );

            case 'impedidos':
                return composicao.some(
                    (magistrado) => magistrado.impedimento === 'IMPEDIDO' || magistrado.impedido === true
                );

            case 'possivelmenteImpedidos':
                return composicao.some(
                    (magistrado) =>
                        magistrado.impedimento === 'POSSIVELMENTE_IMPEDIDO' || magistrado.possivelmenteImpedido === true
                );

            case 'todosNaoVotantes':
                return composicao.some((magistrado) => {
                    const isAusente = magistrado.situacaoPresenca === 'AUSENTE' || magistrado.ausente === true;
                    const isImpedido = magistrado.impedimento === 'IMPEDIDO' || magistrado.impedido === true;
                    const isPossivelmenteImpedido =
                        magistrado.impedimento === 'POSSIVELMENTE_IMPEDIDO' ||
                        magistrado.possivelmenteImpedido === true;

                    return isAusente || isImpedido || isPossivelmenteImpedido;
                });

            default:
                return false;
        }
    };

    // Conta quantos magistrados estão em cada categoria
    contarMagistradosPorTipo = (tipo) => {
        const { composicao } = this.props;

        if (!composicao || !Array.isArray(composicao)) {
            return 0;
        }

        switch (tipo) {
            case 'ausentes':
                return composicao.filter(
                    (magistrado) => magistrado.situacaoPresenca === 'AUSENTE' || magistrado.ausente === true
                ).length;

            case 'impedidos':
                return composicao.filter(
                    (magistrado) => magistrado.impedimento === 'IMPEDIDO' || magistrado.impedido === true
                ).length;

            case 'possivelmenteImpedidos':
                return composicao.filter(
                    (magistrado) =>
                        magistrado.impedimento === 'POSSIVELMENTE_IMPEDIDO' || magistrado.possivelmenteImpedido === true
                ).length;

            case 'todosNaoVotantes':
                return composicao.filter((magistrado) => {
                    const isAusente = magistrado.situacaoPresenca === 'AUSENTE' || magistrado.ausente === true;
                    const isImpedido = magistrado.impedimento === 'IMPEDIDO' || magistrado.impedido === true;
                    const isPossivelmenteImpedido =
                        magistrado.impedimento === 'POSSIVELMENTE_IMPEDIDO' ||
                        magistrado.possivelmenteImpedido === true;

                    return isAusente || isImpedido || isPossivelmenteImpedido;
                }).length;

            default:
                return 0;
        }
    };

    // Verifica se alguma opção está disponível
    algumaOpcaoDisponivel = () => {
        return this.options.some((option) => this.verificarDisponibilidade(option.action));
    };

    handleClickPrincipal = () => {
        const { selectedIndex } = this.state;

        if (selectedIndex === null) {
            // Nenhuma opção selecionada: abre o menu
            if (this.algumaOpcaoDisponivel()) {
                this.setState({ open: true });
            }
        } else {
            // Opção selecionada: abre dialog de confirmação
            this.setState({ dialogAberto: true });
        }
    };

    handleMenuItemClick = (index) => {
        const opcao = this.options[index];

        // Verifica se a opção está disponível
        if (!this.verificarDisponibilidade(opcao.action)) {
            return; // Não faz nada se não estiver disponível
        }

        // Seleciona a opção e fecha o menu
        this.setState({
            selectedIndex: index,
            open: false
        });
    };

    handleToggle = () => {
        if (this.algumaOpcaoDisponivel()) {
            this.setState((prevState) => ({
                open: !prevState.open
            }));
        }
    };

    handleClose = (event) => {
        if (this.anchorRef?.current?.contains(event.target)) {
            return;
        }
        this.setState({ open: false });
    };

    handleConfirmarDialog = () => {
        const { selectedIndex } = this.state;
        const { onAcaoSelecionada } = this.props;

        if (selectedIndex !== null && onAcaoSelecionada) {
            const opcaoSelecionada = this.options[selectedIndex];
            onAcaoSelecionada(opcaoSelecionada.action);
        }

        this.setState({ dialogAberto: false });
    };

    handleCancelarDialog = () => {
        this.setState({ dialogAberto: false });
    };

    handleLimparSelecao = () => {
        this.setState({
            selectedIndex: null,
            dialogAberto: false
        });
    };

    getTextoBotaoPrincipal = () => {
        const { selectedIndex } = this.state;

        if (selectedIndex === null) {
            return 'Pré-preencher não votantes';
        }

        return this.options[selectedIndex].label;
    };

    getIconeBotaoPrincipal = () => {
        const { selectedIndex } = this.state;

        if (selectedIndex === null) {
            return <CheckCircleIcon />;
        }

        return this.options[selectedIndex].icon;
    };

    // Obter mensagem de tooltip para opção desabilitada
    getMensagemTooltip = (tipo) => {
        switch (tipo) {
            case 'ausentes':
                return 'Não há magistrados ausentes na composição';
            case 'impedidos':
                return 'Não há magistrados impedidos na composição';
            case 'possivelmenteImpedidos':
                return 'Não há magistrados possivelmente impedidos na composição';
            case 'todosNaoVotantes':
                return 'Não há magistrados não votantes (ausentes, impedidos ou possivelmente impedidos) na composição';
            default:
                return 'Opção não disponível';
        }
    };

    // Obter lista de magistrados por tipo
    getListaMagistradosPorTipo = (tipo) => {
        const { composicao } = this.props;

        if (!composicao || !Array.isArray(composicao)) {
            return [];
        }

        switch (tipo) {
            case 'ausentes':
                return composicao.filter(
                    (magistrado) => magistrado.situacaoPresenca === 'AUSENTE' || magistrado.ausente === true
                );

            case 'impedidos':
                return composicao.filter(
                    (magistrado) => magistrado.impedimento === 'IMPEDIDO' || magistrado.impedido === true
                );

            case 'possivelmenteImpedidos':
                return composicao.filter(
                    (magistrado) =>
                        magistrado.impedimento === 'POSSIVELMENTE_IMPEDIDO' || magistrado.possivelmenteImpedido === true
                );

            case 'todosNaoVotantes':
                return composicao.filter((magistrado) => {
                    const isAusente = magistrado.situacaoPresenca === 'AUSENTE' || magistrado.ausente === true;
                    const isImpedido = magistrado.impedimento === 'IMPEDIDO' || magistrado.impedido === true;
                    const isPossivelmenteImpedido =
                        magistrado.impedimento === 'POSSIVELMENTE_IMPEDIDO' ||
                        magistrado.possivelmenteImpedido === true;

                    return isAusente || isImpedido || isPossivelmenteImpedido;
                });

            default:
                return [];
        }
    };

    render() {
        const { open, selectedIndex, dialogAberto } = this.state;
        const { disabled, size, variant, color, fullWidth, sx } = this.props;

        const opcaoSelecionada = selectedIndex !== null ? this.options[selectedIndex] : null;
        const algumaDisponivel = this.algumaOpcaoDisponivel();
        const botaoDesabilitado = disabled || !algumaDisponivel;

        // Informações para o diálogo de confirmação
        const quantidadeMagistrados = opcaoSelecionada ? this.contarMagistradosPorTipo(opcaoSelecionada.action) : 0;
        const listaMagistrados = opcaoSelecionada ? this.getListaMagistradosPorTipo(opcaoSelecionada.action) : [];

        return (
            <>
                <ButtonGroup
                    variant={variant}
                    color={color}
                    disabled={botaoDesabilitado}
                    ref={this.anchorRef}
                    aria-label="seletor de pré-preenchimento"
                    size={size}
                    fullWidth={fullWidth}
                    sx={sx}
                >
                    <Button
                        onClick={this.handleClickPrincipal}
                        startIcon={this.getIconeBotaoPrincipal()}
                        sx={{
                            justifyContent: 'flex-start',
                            position: 'relative',
                            whiteSpace: 'nowrap', // Garante apenas uma linha
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                flex: 1,
                                minWidth: 0 // Permite que o texto seja truncado
                            }}
                        >
                            <Typography
                                variant="inherit"
                                sx={{
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}
                            >
                                {this.getTextoBotaoPrincipal()}
                            </Typography>
                        </Box>
                    </Button>
                    <Button
                        aria-controls={open ? 'split-button-menu' : undefined}
                        aria-expanded={open ? 'true' : undefined}
                        aria-label="selecionar opção de pré-preenchimento"
                        aria-haspopup="menu"
                        onClick={this.handleToggle}
                        disabled={!algumaDisponivel}
                        sx={{
                            px: 1,
                            minWidth: '40px',
                            ...(fullWidth && { flex: '0 0 auto' })
                        }}
                    >
                        <ArrowDropDownIcon />
                    </Button>
                </ButtonGroup>

                {/* Menu Dropdown */}
                <Popper
                    sx={{
                        zIndex: 1300,
                        minWidth: 320
                    }}
                    open={open}
                    anchorEl={this.anchorRef.current}
                    role={undefined}
                    transition
                    disablePortal
                >
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            style={{
                                transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
                            }}
                        >
                            <Paper elevation={3}>
                                <ClickAwayListener onClickAway={this.handleClose}>
                                    <MenuList
                                        id="split-button-menu"
                                        autoFocusItem
                                        sx={{ py: 0 }}
                                    >
                                        <MenuItem
                                            disabled
                                            sx={{
                                                py: 1,
                                                backgroundColor: 'background.default',
                                                borderBottom: 1,
                                                borderColor: 'divider'
                                            }}
                                        >
                                            <Typography
                                                variant="caption"
                                                fontWeight="bold"
                                                color="text.secondary"
                                            >
                                                Selecione o tipo de pré-preenchimento:
                                            </Typography>
                                        </MenuItem>

                                        {this.options.map((option, index) => {
                                            const disponivel = this.verificarDisponibilidade(option.action);
                                            const quantidade = this.contarMagistradosPorTipo(option.action);
                                            const isSelected = selectedIndex !== null && index === selectedIndex;

                                            return (
                                                <Tooltip
                                                    key={option.label}
                                                    title={!disponivel ? this.getMensagemTooltip(option.action) : ''}
                                                    placement="left"
                                                    arrow
                                                >
                                                    <span style={{ display: 'block', width: '100%' }}>
                                                        <MenuItem
                                                            selected={isSelected}
                                                            onClick={() =>
                                                                disponivel && this.handleMenuItemClick(index)
                                                            }
                                                            disabled={!disponivel}
                                                            sx={{
                                                                py: 1.5,
                                                                minHeight: 52,
                                                                backgroundColor: isSelected
                                                                    ? 'action.selected'
                                                                    : 'inherit',
                                                                borderLeft: isSelected
                                                                    ? `4px solid ${color}.main`
                                                                    : 'none',
                                                                '& .MuiListItemIcon-root': {
                                                                    minWidth: 40
                                                                },
                                                                '&:hover:not(.Mui-disabled)': {
                                                                    backgroundColor: 'action.hover'
                                                                },
                                                                opacity: disponivel ? 1 : 0.5
                                                            }}
                                                        >
                                                            <ListItemIcon>{option.icon}</ListItemIcon>
                                                            <Box sx={{ flex: 1 }}>
                                                                <Typography
                                                                    variant="body2"
                                                                    fontWeight={isSelected ? 600 : 400}
                                                                >
                                                                    {option.label}
                                                                </Typography>
                                                                <Typography
                                                                    variant="caption"
                                                                    color="text.secondary"
                                                                    sx={{
                                                                        display: 'block',
                                                                        lineHeight: 1.2,
                                                                        mt: 0.5
                                                                    }}
                                                                >
                                                                    {option.descricao}
                                                                </Typography>
                                                            </Box>
                                                            {disponivel && quantidade > 0 && (
                                                                <Typography
                                                                    variant="caption"
                                                                    color="primary.main"
                                                                    sx={{
                                                                        ml: 1,
                                                                        fontWeight: 600,
                                                                        fontSize: '0.75rem',
                                                                        whiteSpace: 'nowrap'
                                                                    }}
                                                                >
                                                                    {quantidade}
                                                                </Typography>
                                                            )}
                                                        </MenuItem>
                                                    </span>
                                                </Tooltip>
                                            );
                                        })}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>

                {/* Dialog de Confirmação */}
                {opcaoSelecionada && (
                    <Dialog
                        open={dialogAberto}
                        onClose={this.handleCancelarDialog}
                        maxWidth="md"
                        fullWidth
                    >
                        <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <WarningIcon color="warning" />
                            Confirmar Pré-preenchimento
                        </DialogTitle>
                        <DialogContent>
                            <Box sx={{ mt: 1 }}>
                                <Typography
                                    variant="body1"
                                    sx={{ mb: 2 }}
                                >
                                    <strong>Ação selecionada:</strong> {opcaoSelecionada.label}
                                </Typography>

                                <Alert
                                    severity="info"
                                    sx={{ mb: 3 }}
                                >
                                    <Typography variant="body1">
                                        {quantidadeMagistrados > 1 ? 'Serão pré-preenchidos' : 'Será pré-preenchido'}{' '}
                                        <strong>
                                            {quantidadeMagistrados} magistrado{quantidadeMagistrados > 1 ? 's' : ''}
                                        </strong>
                                    </Typography>
                                </Alert>

                                <Typography
                                    variant="body1"
                                    sx={{ mb: 2 }}
                                >
                                    {opcaoSelecionada.mensagemConfirmacao}
                                </Typography>

                                {listaMagistrados.length > 0 && (
                                    <Box sx={{ mb: 3 }}>
                                        <Typography
                                            variant="subtitle2"
                                            fontWeight="bold"
                                            sx={{ mb: 1 }}
                                        >
                                            Magistrados que serão pré-preenchidos:
                                        </Typography>
                                        <Box
                                            sx={{
                                                p: 2,
                                                bgcolor: 'background.default',
                                                borderRadius: 1,
                                                maxHeight: 200,
                                                overflow: 'auto'
                                            }}
                                        >
                                            {listaMagistrados.map((magistrado, index) => (
                                                <Box
                                                    key={magistrado.id || index}
                                                    sx={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        py: 1,
                                                        borderBottom:
                                                            index < listaMagistrados.length - 1 ? '1px solid' : 'none',
                                                        borderColor: 'divider'
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            width: 8,
                                                            height: 8,
                                                            borderRadius: '50%',
                                                            bgcolor: 'primary.main',
                                                            mr: 1.5
                                                        }}
                                                    />
                                                    <Typography variant="body2">
                                                        {magistrado.nome || `Magistrado ${index + 1}`}
                                                        {magistrado.sigla && ` (${magistrado.sigla})`}
                                                    </Typography>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                )}

                                <Alert severity="warning">
                                    <Typography
                                        variant="body2"
                                        component="div"
                                    >
                                        <strong>Observação:</strong> Esta ação:
                                        <ul style={{ marginTop: 4, marginBottom: 4, paddingLeft: 20 }}>
                                            <li>
                                                Pré-preenche automaticamente a sinalização de votos para não votantes
                                            </li>
                                            <li>Não altera votos já existentes</li>
                                            <li>Pode ser desfeita manualmente</li>
                                        </ul>
                                    </Typography>
                                </Alert>
                            </Box>
                        </DialogContent>
                        <DialogActions sx={{ px: 3, pb: 2 }}>
                            <Box sx={{ mr: 'auto' }}>
                                <Button
                                    onClick={this.handleCancelarDialog}
                                    color="secondary"
                                    variant="outlined"
                                    endIcon={<CancelIcon />}
                                >
                                    Cancelar
                                </Button>
                                <Button
                                    onClick={this.handleLimparSelecao}
                                    color="secondary"
                                    variant="outlined"
                                    endIcon={<ClearIcon />}
                                    sx={{ ml: 2 }}
                                >
                                    Limpar seleção
                                </Button>
                            </Box>
                            <Box>
                                <Button
                                    onClick={this.handleConfirmarDialog}
                                    variant="contained"
                                    color="primary"
                                    startIcon={<CheckCircleIcon />}
                                    autoFocus
                                >
                                    Confirmar ({quantidadeMagistrados})
                                </Button>
                            </Box>
                        </DialogActions>
                    </Dialog>
                )}
            </>
        );
    }
}

export default PrePreenchimentoSplitButton;
